export default __webpack_public_path__ + "static/media/bold.67a8b64c.svg";